/**
*
* ArchiveTopics
*
*/

import React from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { Card } from 'react-bootstrap';
import ListTopics from './ListTopics.jsx';
import inbox from './inbox@2x.png';
import Img from '../Img.js';
import messages from '../messages.js';
import ConversationsBackButton from '../ConversationsBackButton.jsx';
import useConversationsContext from '../useConversationsContext.js';

const CardBody = styled(Card.Body)`
  margin-bottom: 60px;
`;

function ArchiveTopics() {
  const { topics, topicId } = useConversationsContext();
  const { totalCount } = topics;
  return (
    <>
      <Card.Header className="d-flex justify-content-start mb-3 border-bottom-0 align-items-center">
        <ConversationsBackButton />
        <h2 className="card-title"><FormattedMessage {...messages.archive} /></h2>
      </Card.Header>
      { totalCount === 0 ? (
        <CardBody className="flex-grow-1 d-flex flex-column align-items-center justify-content-center">
          <Img src={inbox} alt="" />
          <div className="text-large mt-4 mx-3 mx-sm-5 text-center">
            <FormattedMessage {...messages.noArchived} />
          </div>
        </CardBody>
      ) : (
        <div className="flex-grow-1 overflow-auto">
          <ListTopics topics={topics} activeId={topicId} />
        </div>
      )}
    </>
  );
}

export default ArchiveTopics;
